<template>
    <div class="settings-credits">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Créditos</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <!-- Alerta -->
        <mu-alert color="info" transition="mu-scale-transition">
            <font-awesome-icon icon="exclamation-triangle" class="icon-lg icon-margin-left"/> Somente clientes com o tipo de assinatura PRÉ PAGO podem receber créditos.
        </mu-alert>

        <br>

        <!-- Créditos -->
        <mu-row gutter>
            <mu-col span="12" sm="12" md="6" lg="5" xl="4">
                <mu-paper :z-depth="1" class="bg-title">
                    <h4>Adicionar crédito</h4>
                </mu-paper>
                <mu-paper :z-depth="1">

                    <br>

                    <mu-form :model="form" class="form-credits">

                        <mu-select label="Selecione um cliente:" filterable v-model="form.id_companies" full-width @change="changeClient()" no-data-text="Nenhum cliente">
                            <mu-option v-for="(item, key) in options.clients" :key="key" :label="item.nick_name" :value="item.id"></mu-option>
                        </mu-select>

                        <div v-if="form.id_companies">
                            <div class="title-extract">
                                <h4>Saldo do cliente <u>{{ getNameClient(form.id_companies) }}</u></h4>
                                <table>
                                    <tbody>
                                        <tr v-for="(item, key) in options.quantity.client" :key="key">
                                            <td>{{ item.service_name }}</td>
                                            <td><u>{{ item.balance }} créditos</u></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <mu-form-item label="Tipo Transação:" class="transaction_type">
                                <mu-radio v-model="form.transaction_type" value="C" label="Creditar"></mu-radio>
                                <mu-radio v-model="form.transaction_type" value="E" label="Estornar"></mu-radio>
                            </mu-form-item>

                            <mu-select label="Selecione um serviço:" filterable v-model="form.id_services" full-width no-data-text="Nenhum serviço">
                                <mu-option v-for="(item, key) in options.services" :key="key" :label="item.name" :value="item.id"></mu-option>
                            </mu-select>

                            <mu-text-field label="Quantidade de créditos:" type="number" v-model.trim="form.quantity" full-width></mu-text-field>

                            <!-- Resumo dos serviços / valores  -->
                            <div class="summary" v-if="service">
                                <mu-row gutter>
                                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                                        {{ service.name }}
                                    </mu-col>
                                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                                        {{ priceFormat(service.ch1_tax) }} unit.
                                    </mu-col>
                                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                                        {{ priceFormat(form.quantity * service.ch1_tax) }}
                                    </mu-col>
                                </mu-row>
                            </div>

                            <mu-button color="primary" round full-width @click="saveForm()" :disabled="!form.id_companies || !form.id_services || !form.quantity">
                                <font-awesome-icon icon="save" class="icon-md icon-margin-left"/>
                                Salvar
                            </mu-button>
                        </div>

                    </mu-form>
                </mu-paper>
            </mu-col>
            <mu-col span="12" sm="12" md="6" lg="7" xl="8" v-if="form.id_companies">
                <div class="filtro">
                    <mu-select label="Selecione um filtro" v-model="credits.paging.type" @change="loadHistory()" full-width no-data-text="Nenhum tipo">
                        <mu-option v-for="(item, key) in options.types" :key="key" :label="item.name" :value="item.type"></mu-option>
                    </mu-select>
                </div>

                <mu-loading text="Aguarde... carregando histórico..." v-if="credits.loading"></mu-loading>

                <mu-paper :z-depth="1" class="bg-title">
                    <h4>Extrato de créditos</h4>
                </mu-paper>

                <div class="credits-list" v-if="!credits.loading">

                    <!-- Listagem -->
                    <mu-paper :z-depth="1" class="list">
                        <mu-data-table stripe :columns="credits.columns" :data="credits.list" class="mu-table-custom">
                            <template slot="empty">
                                <div class="box-table-empty">
                                    <p>Não foi encontrado registros de créditos</p>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <td>{{ dateFormat(scope.row.created_at, 'DD/MM/YYYY HH:II') }}</td>
                                <td>{{ scope.row.services.name }}</td>
                                <td class="is-right">
                                    <span v-if="scope.row.transaction_type == 'C'" class="credit">{{ scope.row.quantity }} C</span>
                                    <span v-else-if="scope.row.transaction_type == 'E'" class="reversal">{{ scope.row.quantity }} E</span>
                                    <span v-else-if="scope.row.transaction_type == 'D'" class="debit">{{ scope.row.quantity }} D</span>
                                    <span v-if="scope.row.transaction_type == 'C' && scope.row.reversed" class="reversal"> (E)</span>
                                </td>
                            </template>
                        </mu-data-table>
                    </mu-paper>

                    <br>

                    <!-- Paginação -->
                    <mu-flex class="paginate" justify-content="center" v-if="credits.paging.total > credits.paging.size">
                        <mu-pagination :total="credits.paging.total" :page-count="5" :page-size="credits.paging.size" :current.sync="credits.paging.page" @change="loadHistory()"></mu-pagination>
                    </mu-flex>

                    <!-- Legenda -->
                    <div class="legend">
                        <table>
                            <tbody>
                                <tr>
                                    <td><strong>LEGENDA:</strong></td>
                                    <td class="credit">C (Crédito)</td>
                                    <td class="debit">D (Débito)</td>
                                    <td class="reversal">E (Estorno)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </mu-col>
        </mu-row>

    </div>
</template>

<script>
    import CreditsServices from '@/services/settings/credits'

    export default {
        name: 'app-settings-credits',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Créditos',
                        disabled: true
                    }
                ],
                options: {
                    clients: [],
                    services: [],
                    quantity: {
                        client: 0,
                        seller: 0
                    },
                    types: [
                        { type: 'all', name: 'Todos' },
                        { type: 'C', name: 'Crédito' },
                        { type: 'D', name: 'Débito' },
                        { type: 'E', name: 'Estorno' }
                    ]
                },
                form: {
                    transaction_type: 'C',
                    id_companies: '',
                    id_services: null,
                    quantity: 0
                },
                credits: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0,
                        type: 'all'
                    },
                    columns: [
                        { title: 'Data', name: 'date' },
                        { title: 'Serviço', name: 'service' },
                        { title: 'Quantidade', name: 'price', align: 'right' }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Carregamos os dados da listagem assim que o componente for criado
         */
        async created () {
            await this.loadClients()
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            /**
             * Pegando os dados da empresa gravados no state
             */
            company () {
                return this.$store.state.company
            },

            service () {
                return this.options.services.find((item) => {
                    return item.id === this.form.id_services
                })
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a listagem de clientes
             */
            async loadClients () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando a lista de clientes.')

                    let result = await CreditsServices.customers()

                    if (result && result.status) {
                        this.options.clients = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os clientes.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Chama o load history, porém resetamos para 1 a paginação para
             * não ter problemas de estar em uma pagina sem dados
             */
            changeClient () {
                this.credits.paging.page = 1
                this.loadHistory()
            },

            /**
             * Carrega o histórico dos créditos de determiando cliente passado
             * como parametro o id
             */
            async loadHistory () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando o extrato da empresa.')

                    this.form.id_services = null

                    let result = await CreditsServices.findAll({
                        company: this.form.id_companies,
                        page: this.credits.paging.page,
                        type: this.credits.paging.type
                    })

                    if (result && result.status) {
                        this.credits.paging.page = result.currentPage
                        this.credits.paging.total = result.rowCount
                        this.credits.list = result.results
                        this.mountServices(this.form.id_companies)
                        this.options.quantity.client = await this.getBalanceById({ idCustomer: this.form.id_companies })
                        this.options.quantity.seller = await this.getBalanceById()
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o resumo de créditos.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Método para carregar o saldo do cliente em real
             */
            async getBalanceById (object) {
                try {
                    let result = await CreditsServices.balanceById(object)

                    if (result && result.status) {
                        return result.results
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo.')
                    return 0
                }
            },

            /**
             * Método para organizar os serviços da empresa selecionada
             * Esses serviços como SMS, Flash, etc...
             */
            async mountServices (idCompany) {
                let result = this.options.clients.find((item) => {
                    return item.id === idCompany
                })

                if (result) {
                    this.options.services = result.services
                }
            },

            /**
             * Pegando o saldo da revenda
             */
            getBalanceServiceBySeller () {
                let find = this.options.quantity.seller.find((item) => {
                    return this.form.id_services === item.service_id
                })
                return find ? find.balance : 0
            },

            /**
             * Método responsável por salvar os dados informados para
             * creditar um quantidade ao cliente selecionado
             */
            async saveForm () {
                try {
                    if (this.form.quantity <= 0) {
                        this.$eventHub.$emit('snackbar', 'error', 'A quantidade não pode ser menor ou igual a 0 (zero).', false)
                        return
                    }

                    // if (this.form.quantity > this.getBalanceServiceBySeller() && !this.isZiad()) {
                    //     throw Error(`Sem créditos suficientes para adicionar a empresa.`)
                    // }

                    this.$eventHub.$emit('loading', true, `${this.form.transaction_type === 'C' ? 'Adicionado' : 'Estornando'} créditos para empresa.`)

                    let result = await CreditsServices.creditReverse(this.form)

                    if (result && result.status) {
                        this.form.quantity = 0
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.loadHistory()
                        return
                    } else if (result && result.code === 420) {
                        this.$eventHub.$emit('snackbar', 'error', result.message, false)
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || `Não foi possível ${this.form.transaction_type === 'C' ? 'adicionar' : 'estornar'} os créditos.`)
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Feito uma busca para encontrar o nome fantasia (nick_name) do cliente
             * que foi selecionado na lista. A busca é feita na própria lista
             */
            getNameClient (idCompanies) {
                let client = this.options.clients.find((item) => {
                    return item.id === idCompanies
                })
                return client ? client.nick_name : ''
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .is-stripe
        background #ccc !important

    .settings-credits
        margin 0

        .mu-alert
            background lighten($yellow, 60%)
            color darken($grey, 40%)
            padding 0 10px
            font-size 12px
            min-height 36px

        .bg-title
            background-gradiente(darken($grey, 20%), $grey)
            padding 10px 20px
            color #fff
            h4
                margin 0
                font-weight normal
                font-size 12px

        .form-credits
            padding 0 20px 20px 20px
            border-radius 5px

            h4
                margin 0

            .summary
                border 1px lighten($grey, 40%) solid
                margin-bottom 20px
                .row
                    padding 5px 0
                    width 100%
                    margin auto
                    background lighten($grey, 60%)

            .transaction_type
                padding-top 10px
                padding-bottom 0

        .title-extract
            margin -10px 0 10px 0
            padding 10px
            border 1px #ccc solid
            border-radius 2px
            background rgba(0, 0, 0, 0.05)
            table
                width 100%
                font-size 11px
                u
                    color $primary
            p
                margin 0
                font-size 11px
            h4
                margin 0
                font-weight 100
                border-bottom 1px #ccc solid
                padding-bottom 5px
                margin-bottom 5px
                u
                    color $primary

        .credits-list
            span
                &.credit
                    color $green
                &.debit
                    color $red
                &.reversal
                    color $orange

        .legend
            margin-top 20px

            table
                tr
                    td
                        padding-right 20px
                        font-size 11px
                        text-transform uppercase

                        &.credit
                            color $green
                        &.debit
                            color $red
                        &.reversal
                            color $orange

</style>
